// extracted by mini-css-extract-plugin
export default {"root__container":"Confirm_root__container__RV6VQ","root__container__actions":"Confirm_root__container__actions__GsSxJ"};